import slEventBus from '../../utils/slEventBus';
import eventBus from './eventBus';

function _setupEvent(schema) {
  slEventBus.on(
    schema.incomingEvent,
    (payload) => {
      const externalEventName = schema.sdkEvent ?? schema.incomingEvent;
      const transformedPayload =
        typeof schema.transform === 'function'
          ? schema.transform(payload)
          : payload;
      eventBus.emit(externalEventName, transformedPayload);
    },
    { debug: process.env.NODE_ENV === 'development' },
  );
}

function _setupEvents(eventsSchema) {
  if (!eventsSchema) return;

  for (const eventSchema of eventsSchema) {
    _setupEvent(eventSchema);
  }
}

export { _setupEvents };
